import React from 'react'
import BaseTick from './BaseTick'
import * as Displays from 'support/displays'

function CurrencyTick (props) {
  const {
    payload
  } = props

  const value = payload.value

  return (
    <BaseTick
      {...props}
      header={null}
      subtitle={<Displays.Number name={null} defaultValue={value} decimals={0} />}
    />
  )
}

export default React.memo(CurrencyTick)
